import { Link } from 'react-router-dom';
import React from "react";
import AddIcon from 'mdi-react/AddIcon';
import MinusIcon from 'mdi-react/MinusIcon';

export const COLUMNS = [
    {
        Header: () => null,
        id: 'expander',
        Cell: ({ row }) => (
            <span {...row.getToggleRowExpandedProps()}>
            {row.isExpanded ? <MinusIcon /> : <AddIcon />}
          </span>
        ),
        width: 30,
        disableSortBy: true,
        canFilter: false,
      },
    {
      Header: (
        <>
          Customer ID
          <br />
          Participant
        </>
      ),
      accessor: "customer_id",
      Cell: ({ row }) => {
        const user_id = row.original.incentco_user_id;
        const program_id = row.original.program_id;

        return (
          <>
            CID: {row.original.customer_id}
            <br />
            PID:{' '}
            {user_id ? (
              <Link to={`/program/${program_id}/user/view/${user_id}`}>
                {user_id}
              </Link>
            ) : (
              <span style={{ color: 'red', fontWeight: 'bold' }}>
                N/A
              </span>
            )}
          </>
        );
      }
    },
    {
        Header: "Status",
        accessor: "status"
    },
    {
        Header: "Full name",
        accessor: "firstname",
        Cell: ({ row, value  }) => (
          row.original.firstname + ' ' + row.original.lastname
        ),
    },
    {
        Header: "Email",
        accessor: "email"
    },
    {
        Header: "LeaseID",
        accessor: "lease_id"
    },
    {
        Header: "Program ID",
        accessor: "program_id",
        Cell: ({ row, value  }) => (
          <Link to={`/program/view/${value}`}>{row.original.program_name}</Link>
        ),
    },
    {
        Header: "Entrata Property Id",
        accessor: "entrata_property_id",
    },
    {
        Header: "Processed",
        accessor: "processed",
        Cell: ({ value }) => (value ? new Date(value).toLocaleString() : ''),
    },
    {
        Header: "Created At",
        accessor: "created_at",
        Cell: ({ value }) => new Date(value).toLocaleString(),
    }
]

export const RenderRowSubComponent = ({ row }) => (
    <div style={{ padding: '20px' }}>
      <p>Unit NUmber: {row.original.unit_number ?? 'N/A'} </p>
      <p>Resident Type: {row.original.resident_type ?? 'N/A'} </p>
      <p>Guarantor: {row.original.guarantor_for ?? 'N/A'} </p>
      <p>-----Tech Info:-----</p>
      <p>LogId: <a href={`/entrata-feed-logs/view/${row.original.entrata_log_id}`}>{row.original.entrata_log_id}</a></p>
      <p>Action: {row.original.action ?? 'N/A'}</p>
      <p>Original action: {row.original.original_action ?? 'N/A'}</p>
      <p>Update Command: {row.original.update_info ?? 'N/A'}</p>
      <p>Processed Error: {row.original.processed_error ?? 'N/A'}</p>
    </div>
);


